import { Box } from '@factorialco/deprecated-design-system'
import { Widget } from '@factorialco/f0-react/dist/experimental'
import { ExpensesEntitiesExpensableResourceTypeEnum } from 'generated/resources/graphql'
import { isEmpty } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { CustomTwoColumnsList } from 'modules/expenses/components/expenses/Detail/_Form/Common/ConfirmationScreen/CustomTwoColumnList'
import CustomWidgetHeaderButton from 'modules/expenses/components/expenses/Detail/_Form/Common/ConfirmationScreen/widgets/CustomWidgetHeaderButton'
import { CustomizationField } from 'modules/expenses/hooks/useExpensesCustomization'
import { Expensable } from 'modules/expenses/types/Expensable'

import { buildExpenseData } from './helpers/buildExpenseData'
import { buildMileageData } from './helpers/buildMileageData'
import { buildPerDiemData } from './helpers/buildPerDiemData'

interface ExpenseInformationWidgetProps {
  expensable: Expensable
  customizationFields: CustomizationField[]
  editable: boolean
  onEdit: () => void
  isOwnExpensable: boolean
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
}

const buildWidgetData = (
  expensable: Expensable,
  customizationFields: CustomizationField[],
  isOwnExpensable: boolean,
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
) => {
  if (resourceType === 'mileage') {
    return buildMileageData(expensable, customizationFields, isOwnExpensable)
  }
  if (resourceType === 'perdiem') {
    return buildPerDiemData(expensable, customizationFields, isOwnExpensable)
  }
  return buildExpenseData(expensable, customizationFields, isOwnExpensable)
}

const ExpenseInformationWidget = ({
  expensable,
  customizationFields,
  editable,
  onEdit,
  isOwnExpensable,
  resourceType,
}: ExpenseInformationWidgetProps) => {
  const list = buildWidgetData(expensable, customizationFields, isOwnExpensable, resourceType)

  if (isEmpty(list)) {
    return null
  }

  return (
    <Box gap="s16" position="relative">
      <Widget
        header={{
          title: i18n.t('expenses_v2.confirmation_screen.expense.information_block.title'),
        }}
      >
        <CustomTwoColumnsList list={list} />
      </Widget>
      {editable && (
        <CustomWidgetHeaderButton
          label={i18n.t('expenses_v2.confirmation_screen.confirmation_screen_block_edit_action')}
          onClick={onEdit}
        />
      )}
    </Box>
  )
}

export default ExpenseInformationWidget
